/* Billing stays outside the theme's Ajax-replaced cart fragments.
   Save to Shopify's cart, never to browser storage. Native form inputs also
   carry the attributes when JavaScript is unavailable. */
if (!customElements.get('ilc-cart-billing')) {
  customElements.define('ilc-cart-billing', class extends HTMLElement {
    connectedCallback() {
      this.queue = Promise.resolve();
      this.status = this.querySelector('[data-billing-status]');
      this.onSubmit = this.onSubmit.bind(this);
      this.addEventListener('input', () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.save().catch(() => {}), 400);
      });
      document.addEventListener('submit', this.onSubmit, true);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      document.removeEventListener('submit', this.onSubmit, true);
    }

    values() {
      return Object.fromEntries(Array.from(this.querySelectorAll('input[name]'), input =>
        [input.name.slice(11, -1), input.value.trim()]));
    }

    save() {
      const attributes = this.values();
      const task = this.queue.catch(() => {}).then(async () => {
        this.message('Guardando datos…');
        try {
          const response = await fetch(this.dataset.updateUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes })
          });
          if (!response.ok) throw new Error('Cart update failed');
          const cart = await response.json();
          if (Object.entries(attributes).some(([key, value]) => (cart.attributes?.[key] || '') !== value)) {
            throw new Error('Billing attributes were not saved');
          }
          this.message('Datos guardados para tu factura.');
        } catch (error) {
          this.message('No pudimos guardar los datos. Revisa tu conexión y vuelve a intentar finalizar la compra.', true);
          throw error;
        }
      });
      this.queue = task;
      return task;
    }

    message(text, error = false) {
      this.status.textContent = text;
      this.status.toggleAttribute('data-error', error);
    }

    async onSubmit(event) {
      const checkout = event.target.id === 'IlcCartPageForm';
      const signup = event.target.matches('[data-bv-form]');
      if ((!checkout && !signup) || this.passThrough === event.target) return;
      event.preventDefault();
      // The existing welcome dialog owns email/consent validation. Let its
      // handler run once, then persist billing before the native signup POST.
      if (this.busy) return;
      this.querySelectorAll('input').forEach(input => { input.value = input.value.trim(); });
      if (checkout && !event.target.reportValidity()) return;
      if (signup) {
        const email = event.target.querySelector('input[type="email"]');
        const consent = event.target.querySelector('input[type="checkbox"]');
        if (!email?.validity.valid || !consent?.checked) return;
      }
      clearTimeout(this.timer);
      this.busy = true;
      const button = event.submitter;
      const signupLabel = button?.querySelector('[data-bv-submit-label]');
      const signupLabelText = signupLabel?.textContent;
      button?.setAttribute('aria-busy', 'true');
      try {
        await this.save();
        this.passThrough = event.target;
        event.target.requestSubmit(button || undefined);
        this.passThrough = null;
      } catch {
        if (signupLabel) signupLabel.textContent = signupLabelText;
        if (signup) {
          try { sessionStorage.removeItem('ilc-bienvenida-submitted'); } catch {}
          event.target.closest('ilc-bienvenida')?.setError?.('email', 'No pudimos guardar los datos de facturación. Revisa tu conexión y vuelve a intentar obtener el descuento.');
        } else {
          this.status.scrollIntoView({ block: 'center', behavior: 'auto' });
        }
      } finally {
        this.busy = false;
        button?.removeAttribute('aria-busy');
      }
    }
  });
}
